<template>
  <div>
    <div class="uppercase text-xs text-gray-500 font-bold">
      <IonSkeletonText v-if="loading" :animated="animateLoading" class="w-2/5 h-4 rounded-md"></IonSkeletonText>
      <slot v-else name="label">Label</slot>
    </div>
    <div class="text-lg text-gray-900 font-medium leading-tight">
      <IonSkeletonText v-if="loading" :animated="animateLoading" class="w-3/4 h-8 rounded-md"></IonSkeletonText>
      <slot v-else name="field"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonSkeletonText } from '@ionic/vue';

defineProps<{ loading?: boolean; animateLoading?: boolean }>();
</script>

<style scoped></style>
